function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { View, Modal, StyleSheet } from 'react-native';
import Card from '../Card';
import BlurView from './BlurView';
import { withTheme } from '../../core/theming';

const ModalAlert = props => {
  const {
    visible,
    onClose,
    children,
    style,
    blurViewProps = {},
    accessibility
  } = props;
  return /*#__PURE__*/React.createElement(Modal, {
    animationType: "fade",
    transparent: true,
    visible: visible,
    onRequestClose: onClose
  }, /*#__PURE__*/React.createElement(View, {
    style: styles.container
  }, /*#__PURE__*/React.createElement(BlurView, _extends({
    blurType: "dark",
    style: styles.blurView
  }, blurViewProps)), /*#__PURE__*/React.createElement(Card, {
    accessibility: accessibility,
    style: [styles.mainView, style]
  }, children)));
};

const styles = StyleSheet.create({
  container: {
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1
  },
  blurView: {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0
  },
  mainView: {
    alignItems: 'center'
  }
});
export default withTheme(ModalAlert);
//# sourceMappingURL=ModalAlert.js.map